export const CERT_DOWNLOADED_EV = "certificate_downloaded";
export const MOTIV_SCAN_COMPLETED = "motivation_scan_completed";
